var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14C11.45 14 10.9793 13.8043 10.588 13.413C10.1967 13.0217 10.0007 12.5507 10 12C10 11.45 10.196 10.9793 10.588 10.588C10.98 10.1967 11.4507 10.0007 12 10C12.55 10 13.021 10.196 13.413 10.588C13.805 10.98 14.0007 11.4507 14 12C14 12.55 13.8043 13.021 13.413 13.413C13.0217 13.805 12.5507 14.0007 12 14ZM12 21C9.68333 21 7.675 20.2377 5.975 18.713C4.275 17.1883 3.3 15.284 3.05 13H5.1C5.33333 14.7333 6.10433 16.1667 7.413 17.3C8.72167 18.4333 10.2507 19 12 19C13.95 19 15.6043 18.321 16.963 16.963C18.3217 15.605 19.0007 13.9507 19 12C19 10.05 18.321 8.396 16.963 7.038C15.605 5.68 13.9507 5.00067 12 5C10.85 5 9.775 5.26667 8.775 5.8C7.775 6.33333 6.93333 7.06667 6.25 8H9V10H3V4H5V6.35C5.85 5.28333 6.88767 4.45833 8.113 3.875C9.33833 3.29167 10.634 3 12 3C13.25 3 14.421 3.23767 15.513 3.713C16.605 4.18833 17.555 4.82967 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7633 9.57833 21.0007 10.7493 21 12C21 13.25 20.7627 14.421 20.288 15.513C19.8133 16.605 19.1717 17.555 18.363 18.363C17.5543 19.171 16.6043 19.8127 15.513 20.288C14.4217 20.7633 13.2507 21.0007 12 21Z",
    fill: "#1B3E61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreBoard);
export default __webpack_public_path__ + "static/media/restore-board.57261e425e37ff7f9b9731034c00084c.svg";
export { ForwardRef as ReactComponent };